document.addEventListener("alpine:init", () => {
  const HeaderMegaMenu = (config = {}) => ({
    menuHandle: config.menuHandle || "",
    sectionEl: null,
    megaMenuEl: null,
    targetAnchor: null,
    isOpen: false,
    forceOpen: false,
    init(rootEl) {
      this.megaMenuEl = rootEl || this.megaMenuEl;
      if (!this.megaMenuEl) return;

      this.sectionEl = this.megaMenuEl.closest(".header__inner");
      if (!this.sectionEl || !this.menuHandle) return;

      this.targetAnchor = this.sectionEl.querySelector(
        `.header__menu a[data-handle="${this.menuHandle}"]`
      );

      if (this.targetAnchor) {
        this.targetAnchor.insertAdjacentElement("afterend", this.megaMenuEl);
        this.bindAnchorEvents();
      }
    },
    bindAnchorEvents() {
      if (!this.targetAnchor) return;
      this._openMenu = () => {
        this.isOpen = true;
      };
      this._closeMenu = () => {
        this.isOpen = false;
      };

      this.targetAnchor.addEventListener("mouseenter", this._openMenu);
      this.targetAnchor.addEventListener("mouseleave", this._closeMenu);
      this.targetAnchor.addEventListener("focus", this._openMenu);
      this.targetAnchor.addEventListener("blur", this._closeMenu);
    },
  });

  window.HeaderMegaMenu = HeaderMegaMenu;
  Alpine.data("HeaderMegaMenu", HeaderMegaMenu);
});
